import ExportReport from './ExportReport';
import React from 'react';
import { modalActionType } from 'utils/constants';
import selectors from 'state/selectors';
import { useSelector } from 'react-redux';
import CreateOrUpdateFilters from './CreateOrUpdateFilters';
import DeleteConfirmationModal from './DeleteConfirmation';

const ModalsContent = () => {
  const actionType = useSelector(selectors.modal.getActionType);

  switch (actionType) {
    case modalActionType.report.EXPORT_REPORT:
      return <ExportReport />;
    case modalActionType.report.SAVE_OR_UPDATE_FILTERS:
      return <CreateOrUpdateFilters />;
    case modalActionType.report.DELETE_PREFERENCE_FILTER:
      return <DeleteConfirmationModal />;
    default:
      return null;
  }
};

export default ModalsContent;
